export default __webpack_public_path__ + "static/media/Mask Group.daf20a72.png";